module.exports = __webpack_public_path__ + "media/customizations/wildflowerranch/logo-new-0279b5d967833b7aa3fa370b11ffb820.png";